import React, { Suspense } from 'react';
import { useIsMounted } from '@wix/da-hooks/pkg/useIsMounted';
import ErrorBoundary from '@wix/da-react-context/pkg/ErrorBoundary';
export default function withLoadableComponent(LoadableComponent, fallback = null) {
    const NewLoadable = (props)=>{
        const isMounted = useIsMounted();
        return !isMounted ? null : /*#__PURE__*/ React.createElement(ErrorBoundary, {
            debugComponent: "withLoadableComponent"
        }, /*#__PURE__*/ React.createElement(Suspense, {
            fallback: fallback
        }, /*#__PURE__*/ React.createElement(LoadableComponent, props)));
    };
    NewLoadable.displayName = `Loadable(${LoadableComponent.displayName})`;
    return NewLoadable;
}
